<template>
    <div class="execution-steps">
        <ul class="execution-steps__list">
            <li v-for="bank in banks" :key="bank.code" class="execution-steps__item">

                <Bank
                :link="{
                        text: bank.name,
                        url: `/calculators/e-ipoteki/?bank=${bank.code}`
                    }"
                />
            </li>
        </ul>

    </div>
</template>

<script>
import Bank from '@/components/ui/Bank';
import { calculatorEipoteka } from '@/api/routes/calculator-eipoteka';

export default {
    name: 'BankList',
    components: {
        Bank
    },
    data() {
        return { banks: [] }
    },
    async mounted() {
        const responseData = await calculatorEipoteka('getBanksAction');
        if (responseData && responseData.result) {
            this.banks = responseData.response;
        }
    }
}
</script>

<style scoped lang="scss">
.execution-steps {
    &__list {
        gap: 15px;
        display: flex;
        justify-content: left;
        flex-wrap: wrap;


    }

    &__item {


    }

    &__comment {
        @include text-normal($font-weight-regular, $line-height-normal);

        margin-top: rem($gap-big);

        color: $primary;

        opacity: .5;

        @media #{$screen-medium} {
            font-size: rem($font-size-small);
        }
    }
}
</style>